var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('client-only',[_c('AToastNotification',{attrs:{"dataTestId":"toastNotification"},on:{"onToastClose":e => _vm.onToastClose(e),"onToastClick":e => _vm.onToastClick(e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }